import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";
import { ColorAA } from "./constants";
import { useAATheme } from "./AAThemeContext";

const styleOverrides = {
  variables: {
    light: {
      diffViewerBackground: ColorAA.lightBeige,
      emptyLineBackground: ColorAA.lightBeige,
    },
    dark: {
      diffViewerBackground: ColorAA.lightBlack,
      emptyLineBackground: ColorAA.lightBlack,
    },
  },
};

const DiffView = ({
  oldValue,
  newValue,
  showDiffOnly = false,
}: {
  oldValue: string | string[] | null;
  newValue: string | string[] | null;
  showDiffOnly?: boolean;
}) => {
  const { isDarkMode } = useAATheme();

  return oldValue === "" ? (
    newValue
  ) : (
    <ReactDiffViewer
      styles={styleOverrides}
      useDarkTheme={isDarkMode}
      oldValue={oldValue || ""}
      newValue={newValue || ""}
      hideLineNumbers={true}
      splitView={false}
      showDiffOnly={showDiffOnly}
      compareMethod={DiffMethod.LINES}
    />
  );
};

export default DiffView;
